import React from 'react';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { Rating } from 'primereact/rating';
import DummyImage from "../../assets/dummy-img.png"
import { Image } from 'primereact/image';
const FeedbackComp = () => {
    return (
        <>
            <form >
                <div className="flex login-main-body align-items-center justify-content-center overflow-hidden">
                    <div className="login-div-border">
                        <div className="w-full surface-card py-8 px-5 sm:px-6">
                            <div className="flex flex-column align-items-center justify-content-center text-lg">
                                <Image
                                    src={DummyImage}
                                    alt="Driver"
                                    width={100}
                                    height={100}
                                    className="border-circle mb-3"
                                />

                                <div className="text-center mb-2">
                                    <h3 className="m-0">John Doe</h3>
                                    <small className="text-secondary">Driver | Owner</small>
                                </div>

                                <h4 className="mt-3 mb-1">How was your trip?</h4>

                                <p className="text-secondary mb-3">Your feedback will help improve app experience.</p>

                                <Rating className="mb-3 text-xl" />

                                <InputTextarea
                                    rows={4}
                                    placeholder="Write your feedback here..."
                                    style={{ width: "300px" }}
                                    className="p-inputtext-sm mb-3"
                                />
                                {/* p-button-rounded  */}
                                <Button label="Submit Review" className="p-button-primary w-10rem mt-2" />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
};

export default FeedbackComp;
